/** saves patrimony info
@payload { Array } - with all accounts info to create patrimony feature
*/
export const SAVE_PATRIMONY_INFO = (state, payload) => {
    state.patrimonyInfo = payload
}

/** saves in our state current state, so when getting to patrimony from browser back click we re-render old display
@payload { Array } - with all accounts info to create patrimony feature
*/
export const SAVE_PATRIMONY_BACK_STATE = (state, payload) => {
    state.savedBackStateInfo = { ...payload }
}
